'use client';
import { SvgIconComponent } from '@mui/icons-material';
import { PolicyType } from '@practium/features/policy';
import styles from './LegalLinksCard.module.css';

interface LegalLink {
	key: PolicyType;
	label: string;
	icon: SvgIconComponent;
}

interface LegalLinksCardProps {
	onOpenModal: (modal: PolicyType) => void;
	links: LegalLink[];
}

export const LegalLinksCard = ({ onOpenModal, links }: LegalLinksCardProps) => {
	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<h3 className={styles.title}>Termos e Políticas</h3>
				<p className={styles.subtitle}>Conheça seus direitos</p>
			</div>

			<div className={styles.links}>
				{links.map((link, index) => {
					const Icon = link.icon;

					return (
						<div key={link.key}>
							<button className={styles.linkItem} onClick={() => onOpenModal(link.key)}>
								<div className={styles.linkContent}>
									<div className={styles.iconWrapper}>
										<Icon className={styles.icon} />
									</div>
									<span className={styles.linkLabel}>{link.label}</span>
								</div>
							</button>

							{index < links.length - 1 && <div className={styles.divider} />}
						</div>
					);
				})}
			</div>
		</div>
	);
};
